<template>
  <div>
    <el-table
      v-loading="loading"
      :data="data"
      size="small"
    >
      <el-table-column
        label="STT"
        width="80"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
        :align="field.align"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'created'">
            {{ scope.row[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else-if="field.key === 'name'">
            {{
              scope.row.translations.vi.name
            }}
          </span>
          <div v-else-if="field.key === 'actions'">
            <div
              v-for="action in scope.row.actions"
              :key="action.id"
              class="w-100"
            >
              {{ action.translation.name }}
            </div>
          </div>
          <div v-else-if="field.key === 'statuses'">
            <div
              v-for="action in scope.row.actions"
              :key="action.id"
              class="w-100"
            >
              {{ action.extra_data.to_state | getStatusName(contractStatuses) }}
            </div>
          </div>
          <span v-else-if="field.key === 'roles'">
            {{
              scope.row.roles.map((a) => a.translation.name).join(', ')
            }}
          </span>
          <span v-else>
            {{ scope.row[field.key] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import CONSTANTS from "@/config/constants";

export default {
  name: "CardList",
  components: {},
  props: {
    data: Array,
    loading: Boolean,
    contractStatuses: Array
  },
  data() {
    return {
      fileType: CONSTANTS.FILE_TYPE,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "step",
          label: "Loại",
          width: 150
        },
        {
          key: "name",
          label: "Tên",
          width: 200
        },
        {
          key: "actions",
          label: "Hành động",
        },
        {
          key: "statuses",
          label: "Trạng thái",
        },
        {
          key: "roles",
          label: "Quyền hạn",
          width: 150,
        },
        {
          key: "created",
          label: "Ngày tạo",
          width: 150,
          align: 'center'
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss"></style>
